import gql from 'graphql-tag';
import apollo from '../../services/apollo';

export const ADD_SURVEY = gql`
  mutation addSurvey($input: AddSurveyInput!) {
    addSurvey(input: $input) {
      survey {
        id
      }
    }
  }
`;

export const EDIT_RESPONDENT_MUTATE = gql`
  mutation ChangeSurveyRespondents($input: ChangeSurveyRespondentsInput!) {
    changeSurveyRespondents(input: $input) {
      survey {
        id
        statuses
        managers {
          respondent {
            id
            firstName
            lastName
            email
          }
          id
          status
        }
        peers {
          respondent {
            id
            firstName
            lastName
            email
          }
          id
          status
        }
        directReports {
          respondent {
            id
            firstName
            lastName
            email
          }
          id
          status
        }
        others {
          respondent {
            id
            firstName
            lastName
            email
          }
          id
          status
        }
      }
    }
  }
`;

const RESET_SURVEY_RESPONDENT_DECLINE_STATUS = gql`
  mutation resetSurveyRespondentDeclinedStatus($input: ResetSurveyRespondentDeclinedStatusInput!) {
    resetSurveyRespondentDeclinedStatus(input: $input) {
      surveyRespondentId
    }
  }
`;

export const resetSurveyRespondentStatus = input => apollo
  .mutate({
    mutation: RESET_SURVEY_RESPONDENT_DECLINE_STATUS,
    variables: {
      input,
    },
    refetchQueries: ['surveyDetailQuery'],
  })
  .then(res => res.data);
